import React, { Fragment, ReactElement, useRef } from "react";

import { WaterfallChart } from "../../../../components/src/charts/WaterfallChart";

const WATERFALL_COLORS = {
    decreasing: "#611A51",
    increasing: "#66725B",
    totals: "#5D6C85"
};

function formatContribution(value: number, isTotal: boolean): string {
    const percent = 100 * value;
    const abs = Math.abs(percent);
    const decimals = abs >= 10 ? 1 : 2;
    const body = percent.toFixed(decimals) + "%";
    if (isTotal) return body;
    return (percent >= 0 ? "+" : "") + body;
}

export function ContributionWaterfall({
    items,
    style,
    onInitialized
}: {
    items: { name: string; value: number }[];
    style?: React.CSSProperties;
    onInitialized?: () => void;
}): ReactElement {
    const notifiedRef = useRef(false);
    const notifyInitialized = () => {
        if (notifiedRef.current || !onInitialized) return;
        notifiedRef.current = true;
        onInitialized();
    };
    if (!items || !items.length) return <p className="text-gray-500">No series to display</p>;

    return (
        <Fragment>
            <WaterfallChart
                items={items.map((item) => ({
                    name: item.name,
                    value: item.value,
                    measure: item.name === "TOTAL" ? "total" : "relative",
                    text: formatContribution(item.value, item.name === "TOTAL")
                }))}
                colors={{
                    increase: WATERFALL_COLORS.increasing,
                    decrease: WATERFALL_COLORS.decreasing,
                    total: WATERFALL_COLORS.totals
                }}
                yFormat={(value) => (value * 100).toFixed(1) + "%"}
                ariaLabel="Contribution"
                height={360}
                style={{ width: "100%", height: "100%", ...style }}
                onReady={notifyInitialized}
            />
        </Fragment>
    );
}
